export const config = {
  apiKey: "AIzaSyC6lpA6huiu5WPIhgiDlFxGIfThPJNGvgE",
  authDomain: "okra-27214.firebaseapp.com",
  databaseURL: "https://okra-27214.firebaseio.com",
  projectId: "okra-27214",
  storageBucket: "okra-27214.appspot.com",
  messagingSenderId: "599957030133",
  appId: "1:599957030133:web:72733b61c9f995ba42f1bc"
};
